import '@/utils/rem'
import '@/assets/css/base.less'
import '@/assets/css/common.less'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import directive from './directive'
import appFunction from './utils/interface'
import randomWord from './utils/clientIdMessage.js'
import 'mint-ui/lib/style.css'

import VueResource from 'vue-resource'

Vue.config.productionTip = true

import {
  MessageBox, Toast, Indicator,
  Picker, Popup, DatetimePicker, Field,
  Button,
  Header,
  Tabbar,
  TabItem,
  Cell,
  Swipe, SwipeItem,
  Switch,
  Actionsheet,
  Checklist
} from 'mint-ui'

import touch from 'vue-directive-touch';
Vue.use(touch);
Vue.component(Button.name,Button)
Vue.component(Header.name,Header)
Vue.component(DatetimePicker.name, DatetimePicker)
Vue.component(Picker.name, Picker)
Vue.component(Popup.name, Popup)
Vue.component(Tabbar.name, Tabbar);
Vue.component(TabItem.name, TabItem);
Vue.component(Field.name, Field);
Vue.component(Cell.name, Cell);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Switch.name, Switch);
Vue.component(Actionsheet.name, Actionsheet);
Vue.component(Checklist.name, Checklist);

Vue.use(VueResource)

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$indicator = Indicator
Vue.prototype.$toast = Toast
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$interaction = appFunction
sessionStorage['client_id'] = randomWord(false, 16)

router.beforeEach((to, from, next) => {
 
  document.getElementById("app").scrollTop = 0;
   
  next()
   
})

new Vue({
  router,
  store,
  ...App
}).$mount('#app')
